import { T }                  from 'defa-object';
import ControlModule          from 'scripts/poppet/control-module';
import template               from './controlNote.jst.html';
import { Vue }                from 'vue/defavue';

const channelNav  = Bb.Radio.channel( 'nav' );

export const ControlNoteView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-note' );
	},
	
	onDomRefresh() {
		let self   = this;
		new Vue( {
			el: '#note',
			
			bb() {
				return {
					model: self.model
				};
			},
			
			methods : {
				editText( ) {
					channelNav.trigger('unit:notes', [self.model.get('id')]);
				},
			}
		} );
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
});

export default  ControlNoteView;
